import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { MasterConstants } from '../../constants/master-constants';
import { AddNewGrower, Address, dashboradDDL, GrowerError, apiResponse } from '../../../models/GrowerListing';

import { LoaderService } from './../../../services/infrastructure/loader.service';
import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { CommonService } from './../../../services/common/common.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as $ from 'jquery';

@Component({
  selector: 'app-grower-add',
  templateUrl: './grower-add.component.html',
  styleUrls: ['./grower-add.component.scss']
})

export class GrowerAddComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  IsFormSubmit = false;
  // Properties used to set form values
  newGrower: AddNewGrower;
  addresses: Address;
  newGrowerError: GrowerError;
  data: any = {};

  // error variables
  error = false;
  ErrorMessage = '';

  // drop down variables for account and state
  accountSearchData: any[] = [];
  stateDS: any[];
  accountDataCount: number;
  accountLoading: boolean;

  // header company code and crop year
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  // variables used for api response
  newGrowerGMK: number;

  // used to indentify component used as a nested in g2g transfer order
  @Input()
  usedAsNestedComp = false;

  @Input() growerSearchType = '';
  // emit a event after adding grower to the system
  @Output()
  GrowerAddToSystem: EventEmitter<any> = new EventEmitter<any>();

  // to enable/disable Save New Grower button based on validations
  createNewGrower = false;
  constructor(
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private sliderModelService: SliderModelService,
    private toastrService: ToastrService,
    private matDialog: MatDialog) {
    // set properties of address Model
    this.addresses = new Address();
    this.addresses.Address1 = '';
    this.addresses.Address2 = '';
    this.addresses.City = '';
    this.addresses.State = null;
    this.addresses.Zip = '';
    // set properties of New Grower Model
    this.newGrower = new AddNewGrower();
    this.newGrower.FirstName = '';
    this.newGrower.LastName = '';
    this.newGrower.BusinessName = '';
    this.newGrower.GrowerCode = '';
    this.newGrower.ABNumber = 0;
    this.newGrower.GLN = '';
    this.newGrowerError = new GrowerError();

    // Set the default value for crop year
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
  }

  ngOnInit() {
    // Filled account and state drop down values and select account value
    this.getDropDownData();
    this.newGrower.ABNumber = this.sliderModelService.initializeCompValue.value;
  }

  // Get account and states drop down data
  getDropDownData() {
    if (this.headerCompany && this.headerYear) {
      this.subscription.push(this.commonService.getGrowerSearchData().subscribe(result => {
        const data = result as dashboradDDL;
        this.accountSearchData = data.accounts as any[];

        // setting state drop down and remove All states value from list
        this.stateDS = data.states as any[];
        this.stateDS = this.stateDS.filter(x => x.value != 'All States');
        this.accountDataCount = this.accountSearchData.length;
      }, error => LolLoggerService.error(error)));
    }
  }

  // Adding validation on add grower screen on save new grower click
  validateAddGrowerInput() {
    this.error = false;
    this.ErrorMessage = '';

    // Validation for address section
    if (this.addresses.Zip.trim() == '' || this.addresses.Address1.trim() == '' || this.addresses.City.trim() == '' || (this.addresses.State == null || this.addresses.State.trim() == '')) {
      this.error = true;
      if (this.addresses.Zip.trim() == '') {
        this.ErrorMessage += 'Please enter zip code.\n';
      }

      if (this.addresses.Address1.trim() == '') {
        this.ErrorMessage += 'Please enter address.\n';
      }

      if (this.addresses.City.trim() == '') {
        this.ErrorMessage += 'Please enter city.\n';
      }

      if (this.addresses.State == null || this.addresses.State.trim() == '') {
        this.ErrorMessage += 'Please select state.\n';
      }
    }

    // Validation for first name, last name, and business name section
    if (this.newGrower.FirstName.trim() == '' && this.newGrower.LastName.trim() == '' && this.newGrower.BusinessName.trim() == '') {
      this.error = true;
      this.ErrorMessage += 'Please enter first name, last name, or business name.\n';
    }

    // Validation for first name and last name section
    if ((this.newGrower.FirstName.trim() != '' && this.newGrower.LastName.trim() == '') || (this.newGrower.FirstName.trim() == '' && this.newGrower.LastName.trim() != '')) {
      this.error = true;

      if (this.newGrower.FirstName.trim() != '' && this.newGrower.LastName.trim() == '') {
        this.ErrorMessage += 'Please enter last name.\n';
      }

      if (this.newGrower.FirstName.trim() == '' && this.newGrower.LastName.trim() != '') {
        this.ErrorMessage += 'Please enter first name.\n';
      }
    }
    if (this.error) {
      this.createNewGrower = false;
      return true;
    } else {
      this.createNewGrower = true;
      return false;
    }
  }

  // Checking each control value to remove error class on focus out
  validate(ctrlName: any, value: any) {
    if (value != '' && value != null && this.IsFormSubmit) {
      switch (ctrlName) {
        case 'businessName':
          this.newGrowerError.BusinessName = false;
          this.checkError();
          break;
        case 'firstName':
          this.newGrowerError.FirstName = false;
          this.checkError();
          break;
        case 'lastName':
          this.newGrowerError.LastName = false;
          this.checkError();
          break;
        case 'address1':
          this.newGrowerError.Address1 = false;
          this.checkError();
          break;
        case 'city':
          this.newGrowerError.City = false;
          this.checkError();
          break;
        case 'state':
          this.newGrowerError.State = false;
          this.checkError();
          break;
        case 'zip':
          this.newGrowerError.Zip = false;
          this.checkError();
          break;
      }
    }
    else {
      this.checkError();
    }
  }

  // Handling validation conditions on focus out
  checkError() {
    this.validateAddGrowerInput();
  }

  // To add new grower and show exception if any
  addGrower(growerForm: NgForm) {
    this.IsFormSubmit = true;
    // validation check
    if (this.validateAddGrowerInput()) {
      return false;
    }
    // removed error class after validation

    // Set values for api call
    if (this.newGrower && this.addresses) {
      this.loaderService.setLoaderStatus(true);
      this.data = {
        CompanyCode: this.headerCompany,
        GrowerApiInput: {
          aBNumber: this.newGrower.ABNumber,
          businessName: this.newGrower.BusinessName,
          firstName: this.newGrower.FirstName,
          lastName: this.newGrower.LastName,
          growerCode: this.newGrower.GrowerCode,
          Addresses: [this.addresses]
        }
      };

      // sending form values and using result.
      this.subscription.push(this.commonService.postNewGrowerAdd(this.data).subscribe(result => {
        const apiRep = result as apiResponse;
        if (apiRep && apiRep.status) {
          this.newGrowerGMK = +apiRep.message;   // get Added grower's GMK value
          this.sliderModelService.setGMK(this.newGrowerGMK); // set value to set grower on order detail screen
          // get Added grower's GMK value
          const newGrowerGMK = +result;

          const newGrowerDetails =
          {
            account: this.newGrower.ABNumber,
            newGrower: result.resultData[0].gmk
          };
          this.sliderModelService.growerProgramData.next([newGrowerDetails]);

          if (!this.usedAsNestedComp) {     // for G2G transfer
            this.sliderModelService.close();
          }
          else {
            this.GrowerAddToSystem.emit(true);
          }
          growerForm.reset();
        }
        else if (apiRep && !apiRep.status) { // validation error received from api
          this.toastrService.warning('Error: ' + apiRep.message);  // show error message on screen returned from api
        }
        this.loaderService.setLoaderStatus(false); // loader close after getting response
        this.IsFormSubmit = false;
      },
        error => LolLoggerService.error(error)));
    }
  }

  // To request new grower
  requestGrower(growerForm: NgForm) {
    this.IsFormSubmit = true;
    // validation check
    if (this.validateAddGrowerInput()) {
      return false;
    }

    // Set values for api call
    if (this.newGrower && this.addresses) {
      this.loaderService.setLoaderStatus(true);
      this.data = {
        CompanyCode: this.headerCompany,
        GrowerApiInput: {
          aBNumber: this.newGrower.ABNumber,
          businessName: this.newGrower.BusinessName,
          firstName: this.newGrower.FirstName,
          lastName: this.newGrower.LastName,
          growerCode: this.newGrower.GrowerCode,
          address1: this.addresses.Address1,
          state: this.addresses.State,
          city: this.addresses.City,
          zip: this.addresses.Zip,
          gln: this.newGrower.GLN
        }
      };

      var messageCode = '';
      if (this.growerSearchType == 'GP') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_GP;
      }
      else if (this.growerSearchType == 'GOT') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_GOT;
      }
      else if (this.growerSearchType == 'SRE') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_SRE;
      }
      else if (this.growerSearchType == 'SCL') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_SCL;
      }
      else if (this.growerSearchType == 'SAME_DEALER_TFR') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_SAME_DEALER_TFR;
      }
      else if (this.growerSearchType == 'OTHER_DEALER_TFR') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_OTHER_DEALER_TFR;
      }
      else if (this.growerSearchType == 'SEED_RESERVATION') {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_SEED_RESERVATION;
      }
      else {
        messageCode = MasterConstants.MESSAGE_REQUEST_NEW_GROWER_GOT;
      }

      // sending form values and using result.
      this.subscription.push(this.commonService.requestNewGrower(messageCode, this.data).subscribe(result => {
        if (result["status"]) {
          this.IsFormSubmit = false;
          this.clearFormData();
          this.confirmationPopup(result["message"], growerForm);
        }
        else {
          this.toastrService.error('Request new grower is not processed in the system.');
        }
        this.loaderService.setLoaderStatus(false); // loader close after getting response
      },
        error => LolLoggerService.error(error)));
    }
  }

  private confirmationPopup(popupMessage: string, growerForm: NgForm) {
    const message = `
            <div class="row">
              <div class="col-md-12 confirmation-message">
                <b>${popupMessage}</b>
              </div>
            </div>`;

    this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      panelClass: 'request-grower-confirmation-box',
      data: { title: null, htmlMessage: message, labelYes: 'My Dealer Bucket', labelNo: 'Close', dialogType: 'confirm', isYesEnable: (this.growerSearchType == 'GOT' ? true : false) }
    }).afterClosed().subscribe(result => {
      // If user selected Yes
      if (result == true) {
        this.redirectMyDealerBucket(growerForm);
      }
      else {
        this.sliderModelService.close();
      }
    });
  }

  // select my dealer bucket
  redirectMyDealerBucket(growerForm: NgForm) {
    this.loaderService.setLoaderStatus(true);
    // fetch or create GMK
    this.subscription.push(this.commonService.mapOrFetchGmk(this.newGrower.ABNumber).subscribe(result => {
      growerForm.reset();
      this.sliderModelService.gmkValue.next(+result);
      this.loaderService.setLoaderStatus(false);
      this.sliderModelService.close();
    },
      error => LolLoggerService.error(error)));
  }

  clearFormData() {
    this.newGrower.BusinessName = '';
    this.newGrower.FirstName = '';
    this.newGrower.GLN = '';
    this.newGrower.LastName = '';
    this.addresses.Address1 = '';
    this.addresses.City = '';
    this.addresses.State = null;
    this.addresses.Zip = '';
  }

  public stateSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.id.toLocaleLowerCase().indexOf(term) > -1
      || item.value.toString().toLocaleLowerCase().indexOf(term) > -1;
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  public keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }
}
